const engageEn = {
  "cod.awaiting": "Waiting for the customer to confirm this cash on delivery order. Fulfillment is on hold until they do, or you confirm after calling them.",
  "cod.mark_confirmed": "Mark as confirmed",
  "cod.confirmed_toast": "Order confirmed. Fulfillment can start.",
  "gift.title": "Gift message",
  "gift.no_message": "This order is a gift (no message).",
  "ret.title": "Returns",
  "ret.description": "Return and exchange requests customers make from their order page.",
  "ret.all": "All returns",
  "ret.manage": "Manage",
  "ret.modal_title": "Return {name}",
  "ret.approve": "Approve",
  "ret.decline": "Decline",
  "ret.receive": "Mark as received",
  "ret.close": "Close return",
  "ret.customer_note": "Customer's note",
  "ret.instructions": "Instructions sent",
  "ret.decline_reason": "Reason given",
  "ret.message": "Message to the customer",
  "ret.message_hint": "With Approve: how to send the items back. With Decline: why. It's emailed to them.",
  "ret.refund_hint": "Refund the returned items from the order, then close the return.",
  "ret.refund_link": "Refund",
  "ret.status.requested": "Requested",
  "ret.status.approved": "Approved",
  "ret.status.declined": "Declined",
  "ret.status.received": "Received",
  "ret.status.closed": "Closed",
  "ret.status.cancelled": "Cancelled",
  "ret.kind.refund": "Refund",
  "ret.kind.exchange": "Exchange",
  "ret.reason.size_too_small": "Too small",
  "ret.reason.size_too_large": "Too large",
  "ret.reason.not_as_described": "Not as described",
  "ret.reason.damaged": "Arrived damaged",
  "ret.reason.wrong_item": "Wrong item sent",
  "ret.reason.changed_mind": "Changed their mind",
  "ret.reason.other": "Other",
  "ret.empty": "No return requests",
  "ret.empty_body": "When customers ask to return items from their order page, the requests show here.",
  "ret.col.return": "Return",
  "ret.col.order": "Order",
  "ret.col.items": "Items",
  "ret.col.status": "Status",
  "ret.col.date": "Requested",
  "rev.title": "Reviews",
  "rev.description": "Average {average}★ from {published} published reviews.",
  "rev.pending": "Waiting",
  "rev.published": "Published",
  "rev.rejected": "Rejected",
  "rev.all": "All",
  "rev.rating": "Rating",
  "rev.any_rating": "Any rating",
  "rev.search": "Search reviews or products",
  "rev.selected": "{n} selected",
  "rev.publish": "Publish",
  "rev.reject": "Reject",
  "rev.delete_title": "Delete these reviews?",
  "rev.delete_body": "They're removed for good, and the product's rating is updated.",
  "rev.bulk_done": "{n} reviews updated.",
  "rev.deleted": "Review deleted.",
  "rev.empty_pending": "No reviews waiting",
  "rev.empty": "No reviews here",
  "rev.empty_body": "Reviews customers write on product pages and from review request emails appear here.",
  "rev.select": "Select review",
  "rev.verified": "Verified buyer",
  "rev.status.pending": "Waiting",
  "rev.status.published": "Published",
  "rev.status.rejected": "Rejected",
  "rev.your_reply": "Your reply",
  "rev.helpful": "{n} found it helpful",
  "rev.reply": "Reply",
  "rev.reply_title": "Reply to {name}",
  "rev.post_reply": "Post reply",
  "rev.reply_hint": "Your reply shows under the review on the product page. Leave it empty to remove it.",
  "ins.wish_title": "Wishlist insights",
  "ins.wish_description": "{n} customers have saved products.",
  "ins.wish_empty": "No saved products yet",
  "ins.wish_empty_body": "When signed-in customers save products, the most wished ones show here.",
  "ins.product": "Product",
  "ins.saves": "Saves",
  "ins.in_stock": "In stock",
  "ins.last_saved": "Last saved",
  "ins.sold_out": "Sold out",
  "ins.stock_title": "Back-in-stock requests",
  "ins.stock_description": "Sold-out items customers asked to be told about. Restock the ones with the most requests first.",
  "ins.stock_empty": "No requests yet",
  "ins.stock_empty_body": "When customers ask to be told about a sold-out item, it shows here.",
  "ins.waiting": "Waiting",
  "ins.notified": "Told",
  "ins.latest": "Latest",
} as const;

export default engageEn;
